import { AuthFailReason } from "../../model/AuthFailReason";

export interface AuthUsernameErrorResponse {
  errors: { code: AuthFailReason }[];
}

export const isAuthUsernameErrorResponse = (
  response: any
): response is AuthUsernameErrorResponse => {
  return response.errors !== undefined;
};
